import React, { createContext, useContext, useState, useEffect } from 'react';
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged
} from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth } from '../firebase';
import { db } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userClaims, setUserClaims] = useState({});

  function signup(email, password) {
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    let unsubscribeClaims = () => {};

    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      console.log("Auth state changed, user:", user);
      setCurrentUser(user);
      
      unsubscribeClaims();
      
      if (user) {
        try {
          const idTokenResult = await user.getIdTokenResult();
          console.log("Initial claims:", idTokenResult.claims);
          setUserClaims(idTokenResult.claims || {});

          unsubscribeClaims = onSnapshot(
            doc(db, "users", user.uid),
            async (snapshot) => {
              const userData = snapshot.data();
              const currentClaimsVersion = userClaims.claimsVersion || 0;
              const newClaimsVersion = userData?.claimsVersion || 0;

              console.log(`Firestore claimsVersion: ${newClaimsVersion}, Context claimsVersion: ${currentClaimsVersion}`);
              
              if (snapshot.exists() && newClaimsVersion > currentClaimsVersion) {
                console.log("Claims version changed. Forcing token refresh...");
                const refreshedTokenResult = await user.getIdTokenResult(true);
                console.log("Refreshed claims:", refreshedTokenResult.claims);
                setUserClaims(refreshedTokenResult.claims || {});
              }
            },
            (error) => {
                console.error("Error listening to user document:", error);
            }
          );
        } catch (error) {
             console.error("Error getting initial ID token or setting up listener:", error);
             setUserClaims({});
        }
      } else {
        setUserClaims({});
      }
      
      setLoading(false);
    });

    return () => {
        unsubscribeAuth();
        unsubscribeClaims();
    };
  }, []);

  const value = {
    currentUser,
    userClaims,
    signup,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 
